import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            AnyVolt
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;